import moment from "moment";

let array_time = [];
array_time.push({ text: "Same time with above", value: 0 });
for (let i = 6 * 3600; i <= 21 * 3600; i = i + 900) {
    let hours = Math.floor(i / 3600);
    let minutes = Math.floor((i - hours * 3600) / 60);
    let ampm = hours >= 12 ? 'pm' : 'am';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? '0' + minutes : minutes;
    let result = hours + ':' + minutes + ' ' + ampm;
    array_time.push({ text: result, value: i });
}


export default {
    appointmentList: [],
    filteredList: [],
    resource: null,
    resourceList: [],
    resourceFilter: [],
    appointmentDetail: {},
    arrayTime: array_time,
    calendarView: {
        // type: "1w",
        start_time: moment().format("YYYY-MM-DD")
    },
    specificDate: null,
    currentId: null,
    appointmentSearchList: [],
    waitList: [],
    walkinWaitList: [],
    appointmentWaitList: []
}
